import {HubConnection} from '@microsoft/signalr';
import {logger} from '../../../lib/helpers';
import {
  ClassroomHubMessage,
  ClassroomKvEntryUpdateModel,
  SimplePeerSignal
} from '../models/classroom-models';
import {UserMediaState} from '../video/models';

export type ClassroomTask = (connection: HubConnection) => Promise<ClassroomHubMessage>;

function echo(message: string): ClassroomTask {
  return (connection) => {
    logger.log('ClassroomHub.echo');
    return connection.invoke<ClassroomHubMessage>(
      'echo', message);
  };
}

function joinAsTeacher(classroomId: number, isPreview: boolean): ClassroomTask {
  return (connection) => {
    logger.log('ClassroomHub.joinAsTeacher');
    return connection.invoke<ClassroomHubMessage>('joinAsTeacher', classroomId, isPreview);
  };
}

function joinAsStudent(classroomId: number): ClassroomTask {
  return (connection) => {
    logger.log('ClassroomHub.joinAsStudent');
    return connection.invoke<ClassroomHubMessage>('joinAsStudent', classroomId);
  };
}

function setCurrentPushableBlock(pushableBlockSnapshotId: number): ClassroomTask {
  return (connection) => {
    logger.log('ClassroomHub.setCurrentPushableBlock');
    return connection.invoke<ClassroomHubMessage>(
      'setCurrentPushableBlock', pushableBlockSnapshotId);
  };
}

function getKeyValuesPart(changeStamps: readonly number[]): ClassroomTask {
  return (connection) => {
    logger.log('ClassroomHub.getKeyValuesPart');
    return connection.invoke<ClassroomHubMessage>(
      'getKeyValuesPart', changeStamps);
  };
}

function updateKeyValues(keyValues: readonly ClassroomKvEntryUpdateModel[]): ClassroomTask {
  return (connection) => {
    logger.log('ClassroomHub.updateKeyValues', keyValues);
    return connection.invoke<ClassroomHubMessage>(
      'updateKeyValues', keyValues);
  };
}

function simplePeerSignal(signal: SimplePeerSignal): ClassroomTask {
  return (connection) => {
    logger.log('ClassroomHub.simplePeerSignal', signal);
    return connection.invoke<ClassroomHubMessage>(
      'simplePeerSignal', signal);
  };
}

function updateMediaState(state: UserMediaState): ClassroomTask {
  return (connection) => {
    logger.log('ClassroomHub.updateMediaState', state);
    return connection.invoke<ClassroomHubMessage>(
      'updateMediaState', JSON.stringify(state));
  };
}

class ClassroomTasksClass {
  readonly echo = echo;
  readonly joinAsStudent = joinAsStudent;
  readonly joinAsTeacher = joinAsTeacher;
  readonly setCurrentPushableBlock = setCurrentPushableBlock;
  readonly getKeyValuesPart = getKeyValuesPart;
  readonly updateKeyValues = updateKeyValues;
  readonly simplePeerSignal = simplePeerSignal;
  readonly updateMediaState = updateMediaState;
}

export const ClassroomTasks = new ClassroomTasksClass();
